/** Field-level change handlers for the task form. */
import { useTaskFormCoreFieldHandlers } from '@/features/tasks/hooks/form/use-task-form-core-field-handlers';
import { useTaskFormTagHandlers } from '@/features/tasks/hooks/form/use-task-form-tag-handlers';

export const useTaskFormFieldHandlers = ({ setTask, allTasks, isRollup }) => {
  const coreHandlers = useTaskFormCoreFieldHandlers({
    setTask,
    allTasks,
    isRollup,
  });
  const tagHandlers = useTaskFormTagHandlers({ setTask });

  return { ...coreHandlers, ...tagHandlers };
};
